import { useVisibleSchedule } from '../context/VisibleSchedulesContext';
import type { ItemsTableRow } from '../types';
import { DateCell } from './DateCell';
import { CellTextSkeleton } from './withSkeleton';

type ScheduleField =
  | 'forecastedStartDateTime'
  | 'forecastedFinishDateTime'
  | 'latestFinishDateTime';

export const ScheduleDateCell = ({ row, field }: { row: ItemsTableRow; field: ScheduleField }) => {
  const schedule = useVisibleSchedule(row.id);

  if (schedule === undefined) return <CellTextSkeleton />;
  const dateString = schedule?.[field] ?? null;
  return <DateCell value={dateString ? new Date(dateString) : undefined} />;
};
